import { IRestfulApiService } from '@/lib/apiService'
import { GetFilterResponseDTO, IMutationCommand } from '@bookips/solvook-api-shared'

export class GetFiltersCommand implements IMutationCommand<any, any, GetFilterResponseDTO> {
	private apiService: IRestfulApiService

	constructor(apiService: IRestfulApiService) {
		this.apiService = apiService
	}

	execute(any): Promise<GetFilterResponseDTO> {
		const url = `/products/old_filters`

		return this.apiService.fetch<GetFilterResponseDTO>(url, {}).then((res) => res.data)
	}
}
